import React from 'react';
import styled from 'styled-components';

import { If, Then, Else} from 'react-if';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

// Assets
import ImgBgMatchDay from '../assets/ruboalastras/bgMatchDay.jpg';

const MatchDay = styled.div`
     .match{
          background: #fff url(${ImgBgMatchDay});
          background-position: center top;
          background-size: 100% auto;
          
          display: grid;
          padding: 20px;
          gap:10px;
          grid-template-columns: 40% 20% 40%;
          align-items: center;
          justify-content: center;
          text-align: center;
          .vs{
               font-size: 50px;
               font-weight: bold;
               text-align: center;
               color:var(--color-primary);
               align-self: end;
          }
          img{
               width: 100%;
               &.small{
               max-width: 95%;
               }
          }
     }
     .timestamp, .goles{
          text-align: center;
          color:#fff;
          font-size: 20px;
          padding: 10px 12px;
          font-weight: bold;
          background-color: #e23e3c;
     }
     .goles{
          font-size:50px;
     }
     .fechas{
          text-align: center;
          color: var(--color-azul);
          font-size: 23px;
          line-height: 25px;
          padding: 15px 10px;
          font-weight: 700;
     }
     `;


if (!String.prototype.capitalize) {
  Object.defineProperty(String.prototype, 'capitalize', {
    value: function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    },
    configurable: true,
  });
}

export default  ({showResultPrevGame,lastGame, nextGame}:{showResultPrevGame:boolean, lastGame?:any, nextGame?:any}) => {

     return (
          <MatchDay>                                
               <If condition={showResultPrevGame}>
                    <Then>
                         <div className='match'>
                              <div><img src={lastGame?.team_local?.url_imagen_path} /></div>
                              <div className='vs'>vs</div>
                              <div><img src={lastGame?.team_visitor?.url_imagen_path} className='small' /></div>
                         </div>
                         <div className='goles'>
                              {lastGame?.goles_local} - {lastGame?.goles_visitor}
                         </div>
                         <div className='fechas'>
                              {lastGame?.tournament.nombre}. {lastGame?.round.nombre}. <br />
                              {moment(lastGame?.fecha).format('dddd').capitalize()} {moment(lastGame?.fecha).format('D [de] MMMM YYYY, hh:mm A')} <br />
                                   Estadio {lastGame?.team_local.nombre_estadio}
                         </div>
                    </Then>
                    <Else>
                         <If condition={nextGame}>
                              <Then>
                              <div className='match'>
                                   <div><img src={nextGame?.team_local?.url_imagen_path} /></div>
                                   <div className='vs'>vs</div>
                                   <div><img src={nextGame?.team_visitor?.url_imagen_path} className='small' /></div>
                              </div>
                              <div className='timestamp'>
                                        PRÓXIMO PARTIDO <br />
                                   {nextGame?.tournament.nombre}. {nextGame?.round.nombre}. 
                                   {' '}
                                   <If condition={false}>
                                        <Then>
                                             Pendiente por definir <br />
                                        </Then>
                                        <Else>
                                             {moment(nextGame?.fecha).format('dddd').capitalize()} {moment(nextGame?.fecha).format('D [de] MMMM YYYY, hh:mm A')} <br />
                                        </Else>
                                   </If>
                                        Estadio {nextGame?.team_local.nombre_estadio}
                              </div>
                              </Then>
                         </If> 
                    </Else>
               </If>
          </MatchDay>
     );

};